import { getBrowserBridgeAPI as getBrowserBridgeAPIBase } from '@atlassian/rovo-content-bridge-api';
export * from '@atlassian/rovo-content-bridge-api';

export const getBrowserBridgeAPI = (): ReturnType<typeof getBrowserBridgeAPIBase> => {
  if (globalThis.ATLASSIAN_CANVAS?.mockBridgeAPI === undefined) {
    return getBrowserBridgeAPIBase();
  } else {
    return globalThis.ATLASSIAN_CANVAS.mockBridgeAPI;
  }
};
